import axios from 'axios';

const UPTAKE_INSIGHTS_PATH = '/api/UptakeInsights';
const STATUS_ENDING = '/status';
const UNIT_ENDING = '/unit';
const ADD_TO_SO_ENDING = '/add-to-so';
class UptakeInsightsService {
  cleanParams(parameters) {
    if (!parameters || typeof parameters !== 'object') {
      return parameters;
    }

    const cleaned = {};
    Object.keys(parameters).forEach(key => {
      const value = parameters[key];

      if (value == null) {
        return;
      }

      if (Array.isArray(value) && value.length === 0) {
        return;
      }

      if (value === '') {
        return;
      }

      cleaned[key] = value;
    });

    return cleaned;
  }

  async searchUptakeInsights(parameters) {
    let lastError = null;
    const cleanedParameters = this.cleanParams(parameters);

    const path = UPTAKE_INSIGHTS_PATH;
    try {
      return await axios.get(path, {
        params: cleanedParameters
      });
    } catch (error) {
      if (error?.response?.status !== 404) {
        throw error;
      }
      lastError = error;
    }

    throw lastError;
  }

  async updateInsightStatus(params) {
    const url = `${UPTAKE_INSIGHTS_PATH}/${encodeURIComponent(params.uptakeInsightId)}/${encodeURIComponent(
      params.status
    )}${STATUS_ENDING}`;
    return await axios.post(url);
  }
  async fetchUnitUptakeInsights(unitId) {
    const url = `${UPTAKE_INSIGHTS_PATH}/${encodeURIComponent(unitId)}${UNIT_ENDING}`;
    return await axios.get(url);
  }
  async addUptakeInsightsToSO(params) {
    const url = `${UPTAKE_INSIGHTS_PATH}${ADD_TO_SO_ENDING}`;
    return await axios.post(url, params);
  }
}

export default new UptakeInsightsService();
